module.exports = __webpack_public_path__ + "7f3bfc770bfb1270edf02e9ebcefe0ff.svg";